import { adminGoogleTagManager } from 'bundles/event-tracking/constants';
import { loadGTMScript } from 'bundles/event-tracking/gtmUtils';

export default class AdminGoogleTagManager {
  ensureLibLoaded() {
    return loadGTMScript(adminGoogleTagManager.url);
  }
}
